import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
// state
import { useSoFormStepsApi, useSoFormStepsState } from '../../SoForm.context';
// components
import SoFormButton from '../../components/other/SoFormButton';
import SoFormContainer from '../../components/layout/SoFormContainer';
import SoFormStepPriceError from './SoFormStepPriceError';
import { ChevronRightIcon } from 'refactored/ui/icons';
import LoadSpinner from 'components/LoadSpinner';
import SoFormStepPriceZipcodeInfo from './SoFormStepPriceZipcodeInfo';
import { useTranslation } from 'react-i18next';

const SoFormStepPriceFooter = ({ className }) => {
  const stepsApi = useSoFormStepsApi();
  const stepsState = useSoFormStepsState();

  const isLoading = stepsState.price.isLoading;

  const isZipcode = stepsState.configuration.isZipcode;
  const showZipCodeError = stepsState.price.showZipcodeError;
  const hideContinueButton = isZipcode && showZipCodeError;

  const finalClassName = `${className} ${
    hideContinueButton ? 'hideContinueButton' : ''
  }`;
  const { t } = useTranslation('Catalog');

  return (
    <div className={finalClassName}>
      <SoFormStepPriceZipcodeInfo />
      <SoFormStepPriceError />
      <SoFormContainer>
        <SoFormButton inverse={true} onClick={stepsApi.onPriceGoBack}>
          {t('price.go_to_previus_step')}
        </SoFormButton>
        {!hideContinueButton && (
          <SoFormButton disabled={isLoading} onClick={stepsApi.onPriceSubmit}>
            {!isLoading && (
              <>
                {t('price.add_complements')}
                <ChevronRightIcon />
              </>
            )}
            {isLoading && <LoadSpinner />}
          </SoFormButton>
        )}
      </SoFormContainer>
    </div>
  );
};

SoFormStepPriceFooter.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepPriceFooter)`
  width: 100%;
  padding: 0px;
  padding-bottom: 16px;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  & > ${SoFormContainer} {
    gap: 10px;
    ${SoFormButton} {
      max-width: 50%;
    }
  }
  &.hideContinueButton {
    & > ${SoFormContainer} {
      ${SoFormButton} {
        max-width: 100%;
      }
    }
  }
`;
